<template>
  <span v-if="!isInMatchDetails"
    class="bto-sb-event-favorite"
    :class="{
      'bto-sb-event-favorite-add': isFavorite && !isUS,
      'bto-sb-sportlist-menu-tournament-favorite': isFixture,
      'bto-sb-active' : isFavorite && isUS
    }">
    <a
      href="#"
      :title="isFavorite ? t('W.RemFav') : t('W.AddFav')"
      :class="(isFavorite && isFixture) ? 'bto-sb-sportlist-menu-tournament-favorite-active' : null"
      @click.prevent="changeFavorite"
    ></a>
  </span>
  <a v-else
      href="#"
      :title="isFavorite ? t('W.RemFav') : t('W.AddFav')"
      class="bto-sb-favorite"
      :class="isFavorite  ? 'bto-sb-active' : null"
      @click.prevent="changeFavorite"
    ></a>
</template>

<script>
  import store from '../../store';
  import { EventBus } from '../../services/event-bus-service';
  import { LAYOUT_NAME } from '../../models/enums/layout-const';

  export default {
    name: 'FavoriteComponent',
    data() {
      return {
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
      };
    },
    props: {
      match: {
        type: Object,
        default: () => { },
      },
      isFixture: {
        type: Boolean,
        required: false,
        default: false,
      },
      isInMatchDetails: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isFavorite() {
        return store.state.favoritesModule.favorites.findIndex(m => m.matchId === this.match.matchId) > -1;
      },
    },
    methods: {
      changeFavorite() {
        if (this.isFavorite) {
          store.commit('removeFavorite', this.match.matchId);
          EventBus.$emit('unfavorite', this.match.matchId);
        } else {
          const prematchDate = this.match.utcDate || this.match.apiDateTime;
          store.commit('addFavorite', {
            matchId: this.match.matchId,
            betRadarId: this.match.betRadarId,
            sportId: this.match.sportId,
            isLive: this.match.isLiveMatch === true,
            dateStarted: this.match.hasOwnProperty('isLiveMatch') ? new Date(Date.now()).getTime() : new Date(prematchDate).getTime(),
          });
          if (this.match.isLiveMatch !== true) {
            store.commit('addFavoriteMatch', this.match);
          }
          // EventBus.$emit('getFavoriteMatches', this.match);
        }
        return false;
      },
    },
  };
</script>